"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Eval3D = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var Eval3D = /*#__PURE__*/function () {
  function Eval3D(json) {
    var hasGraphic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var hasPrices = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var hasBom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    (0, _classCallCheck2["default"])(this, Eval3D);
    this.extraEval = null;
    this.altezze = null;
    this.eval3dris = null;
    this.classicPlacer = [];
    this.dragger2D = [];
    this.erp = null;
    this.job = null;
    this.placer = null;
    this.reg = null;
    this.rinfo = null;
    this.rule = null;
    this.uniqueid = null;
    this.cmodel = null;
    this.model = null;
    this.hasGraphic = null;
    this.hasPrices = null;
    this.hasBom = null;
    this.hasClosetErrror = false;
    this.hasGraphic = hasGraphic;
    this.hasPrices = hasPrices;
    this.hasBom = hasBom;
    this.classicPlacer = json.classicPlacer;
    this.job = json.job;
    this.placer = json.placer;
    this.reg = json.reg;
    this.rinfo = json.rinfo;
    this.rule = json.rule;
    this.uniqueid = json.uniqueid;
    this.cmodel = json.cmodel;
    this.model = json.model;
    this.dragger2D = json.dragger2D;
    this.hasClosetErrror = json.hasClosetErrror;
    if (hasGraphic) this.eval3dris = json.obj;
    if (hasPrices) this.erp = json.erp;
    Eval3D.elabMagicLink(json.extraEval);
    this.extraEval = json.extraEval;
    Eval3D.elabTabAltezze(json.altezze);
    this.altezze = json.altezze;
  }
  (0, _createClass2["default"])(Eval3D, null, [{
    key: "elabTabAltezze",
    value: function elabTabAltezze(altezze) {
      if (!altezze) return;
      if (!altezze.hasOwnProperty('link')) altezze.link = 0;
      if (!altezze.hasOwnProperty('altezzalink')) altezze.altezzalink = 0;
    }
  }, {
    key: "elabMagicLink",
    value: function elabMagicLink(extradata) {
      if (extradata.mLink) {
        if (!extradata.mLink.x1) extradata.mLink.x1 = 0;
        if (!extradata.mLink.y1) extradata.mLink.y1 = 0;
        if (!extradata.mLink.x2) extradata.mLink.x2 = 0;
        if (!extradata.mLink.y2) extradata.mLink.y2 = 0;
        if (!extradata.mLink.x3) extradata.mLink.x3 = 0;
        if (!extradata.mLink.y3) extradata.mLink.y3 = 0;
        if (!extradata.mLink.x4) extradata.mLink.x4 = 0;
        if (!extradata.mLink.y4) extradata.mLink.y4 = 0;
        if (!extradata.mLink.more) extradata.mLink.more = 0;
        if (!extradata.mLink.x5) extradata.mLink.x5 = 0;
        if (!extradata.mLink.y5) extradata.mLink.y5 = 0;
        if (!extradata.mLink.hTerra) extradata.mLink.hTerra = 0;
        if (!extradata.mLink.triangulate) extradata.mLink.triangulate = 0;
      }
    }
  }]);
  return Eval3D;
}();
exports.Eval3D = Eval3D;
//# sourceMappingURL=Eval3D.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/Eval3D.js
// module id = 483
// module chunks = 142